// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2PAlv","list":"PatternAutocomplete_list__2p2o8"};